import React, { useEffect, useRef, useState } from "react";

import styles from './styles.module.css';
import { BuscarImagensLista, listarJob } from "../../service/ServiceJob";
import { ProgressSpinner } from "primereact/progressspinner";
import { Galeria } from ".";

export function GaleriaJob(props) {
    const pedido = JSON.parse(sessionStorage.getItem('pedido'));

    const [isOpen, setIsOpen] = useState(false);
    const [listJobs, setListJobs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingImages, setIsLoadingImages] = useState(false);
    const [jobSelecionado, setJobSelecionado] = useState();
    const [jobImageSelecionado, setJobImageSelecionado] = useState([]);
    const [imageSelecionada, setImageSelecionada] = useState(0);
    const [msgLoading, setMsgLoading] = useState("Carregando imagens...");
    const currentJobRef = useRef(null);

    useEffect(() => {
        listarJobs();
    }, []);

    useEffect(() => {
        if (jobSelecionado) {
            JobSelected();
        }
    }, [jobSelecionado]);

    if (isLoading) {
        return <Loading msg={msgLoading} />;
    }

    function openMenu() {
        setIsOpen(!isOpen);
    }

    async function listarJobs() {
        setIsLoading(true);

        try {
            const response = await listarJob(pedido.AcNumber);

            if (response) {
                setListJobs(response);
                setJobSelecionado(response[0]);
                setIsLoading(false);

                response.forEach(async (job, index) => {
                    try {
                        const images = await BuscarImagensLista(job.Id);
                        setListJobs(prev => {
                            const updated = [...prev];
                            updated[index] = { ...updated[index], Minuature: images[0]?.ImageBase64 };
                            return updated;
                        });
                    } catch (_) {}
                });
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    }

    function selecionarJob(job) {
        setJobSelecionado(job);
    }

    async function JobSelected() {
        const currentJob = jobSelecionado;
        currentJobRef.current = currentJob.Id;
        setIsLoadingImages(true);
        setImageSelecionada(0);
        try {
            const response = await BuscarImagensLista(currentJob.Id);

            if (currentJobRef.current !== currentJob.Id) return;

            setJobImageSelecionado(response ?? []);
            setIsLoadingImages(false);
        } catch (error) {
            if (currentJobRef.current === currentJob.Id) setIsLoadingImages(false);
            console.log(error);
        }
    }

    function listaJobs() {
        const list = [];

        listJobs.forEach(job => {
            list.push(job.Id);
        });

        return list;
    }

    return (
        <Galeria.Root styles={styles}>
            <Galeria.Header props={props} styles={styles} listJobs={listJobs} fn={() => openMenu()} isOpen={isOpen} fnPrintAll={() => listaJobs()} setIsLoading={setIsLoading} setMsgLoading={setMsgLoading} />
            {listJobs.length > 0 ? (
                <Galeria.Main styles={styles}>
                    <Galeria.Jobs styles={styles} listJobs={listJobs} isOpen={isOpen} setIsOpen={setIsOpen} jobSelecionado={jobSelecionado} selecionarJob={selecionarJob} setIsLoading={setIsLoading} setMsgLoading={setMsgLoading} />
                    <Galeria.Images
                        styles={styles}
                        setImageSelecionada={setImageSelecionada}
                        imageSelecionada={imageSelecionada}
                        jobImageSelecionado={jobImageSelecionado}
                        isLoadingImages={isLoadingImages}
                    />
                </Galeria.Main>
            ) : (
                <Galeria.NoImage styles={styles} />
            )}
        </Galeria.Root>
    );
}

function Loading({ msg }) {
    return (
        <div className={styles.loading}>
            <ProgressSpinner />
            <p>{msg} {msg === 'Gerando PDF' && <span id="progress"></span>}</p>
        </div>
    )
}
